export default "__VITE_ASSET__f52c441d__"